import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Layout from "./layout/Layout";
import Login from "./pages/Login";
import SignUp from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import Lead from "./pages/Lead";
import Dashboard from "./pages/Dashboard";
import Staff from "./pages/Staff";
import Task from "./pages/Task";
import Reminder from "./pages/Reminder";
import Meeting from "./pages/Meeting";
import Todo from "./pages/Todo";
import Chat from "./pages/Chat";
import Customer from "./pages/Customer";
import Leave from "./pages/Leave";
import Calendar from "./pages/Calendar";
import Profile from "./layout/ProfileDetail";
import Setting from "./pages/Setting";

import AllUserList from "./pages/user/AllUserList";
import ActiveUserList from "./pages/user/ActiveUserList";
import InActiveUserList from "./pages/user/InActiveUserList";
import GameSettings from "./pages/game_settings/GameSetting";
import AllWalletTransaction from "./pages/wallet_transaction/AllWalletTransaction";
import WinWalletTransaction from "./pages/wallet_transaction/WinWalletTransaction";
import LossWalletTransaction from "./pages/wallet_transaction/LossWalletTransaction";
import DepositPending from "./pages/deposit_withdrawal/DepositPending";
import DepositApprove from "./pages/deposit_withdrawal/DepositApprove";
import DepositRejected from "./pages/deposit_withdrawal/DepositRejected";
import WithdrawPending from "./pages/deposit_withdrawal/WithdrawPending";
import WithdraApproved from "./pages/deposit_withdrawal/WithdraApproved";
import WithdraRejected from "./pages/deposit_withdrawal/WithdraRejected";
import AdminList from "./pages/admin/AdminList";
import AddAdmin from "./pages/admin/AddAdmin";
import AdminEarning from "./pages/admin/AdminEarning";
import UpiSetting from "./pages/admin/UpiSetting";
import QrSetting from "./pages/admin/QrSetting";
import AccountSetting from "./pages/admin/AccountSetting";

import DepositChfs from "./pages/Setting/DepositChfs";

import PenaltyHistory from "./pages/Transaction_Manager/PenaltyHistory";
import BonusHistory from "./pages/Transaction_Manager/BonusHistory";
import DepositHistory from "./pages/Transaction_Manager/DepositHistory";
import WithdrawHistory from "./pages/Transaction_Manager/WithdrawHistory";
import AviatorGameSetting from "./pages/game_settings/AviatorGameSetting";
import GeneralSetting from "./pages/Setting/GeneralSetting";
import PrivacyPolicy from "./pages/Setting/PrivacyPolicy";
import PenaltyReport from "./pages/Report/PenaltyReport";
import BonusReport from "./pages/Report/BonusReport";
import DepositReport from "./pages/Report/DepositReport";
import WithdrawReport from "./pages/Report/WithdrawReport";
import ContentList from "./pages/Setting/ContentList";
import AddGmail from "./pages/game_settings/AddGmail";
import MailList from "./pages/game_settings/MailList";

import Kyclistverify from "./pages/kyc/Kyclistverify";
import Kyclistpending from "./pages/kyc/Kyclistpending";
import KyclistReject from "./pages/kyc/KyclistReject";
import Userdetails from "./pages/user/Userdetails";
import Ledger from "./pages/user/Ledger";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");

  return token ? <Layout /> : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/lead" element={<Lead />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/task" element={<Task />} />
          <Route path="/reminder" element={<Reminder />} />
          <Route path="/meeting" element={<Meeting />} />
          <Route path="/to-do" element={<Todo />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/leave" element={<Leave />} />
          <Route path="/user-details/:userId" element={<Userdetails />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/ledger/:userId" element={<Ledger />} />
          <Route path="/all-user-list" element={<AllUserList />} />
          <Route path="/active-user-list" element={<ActiveUserList />} />
          <Route path="/inactive-user-list" element={<InActiveUserList />} />
          <Route path="/game-settings" element={<GameSettings />} />
          <Route
            path="/all-wallet-transaction"
            element={<AllWalletTransaction />}
          />
          <Route path="/win-transaction" element={<WinWalletTransaction />} />
          <Route path="/loss-transaction" element={<LossWalletTransaction />} />
          <Route path="/deposit-pending" element={<DepositPending />} />
          <Route path="/deposit-approve" element={<DepositApprove />} />
          <Route path="/deposit-rejected" element={<DepositRejected />} />
          <Route path="/withdrawal-pending" element={<WithdrawPending />} />
          <Route path="/withdrawal-approve" element={<WithdraApproved />} />
          <Route path="/withdrawal-rejected" element={<WithdraRejected />} />
          <Route path="/kyc-pending" element={<Kyclistpending />} />
          <Route path="/kyc-verify" element={<Kyclistverify />} />
          <Route path="/kyc-reject" element={<KyclistReject />} />
          <Route path="/admin-list" element={<AdminList />} />
          <Route path="/add-admin" element={<AddAdmin />} />
          <Route path="/admin-earning" element={<AdminEarning />} />
          <Route path="/upi-setting" element={<UpiSetting />} />
          <Route path="/qr-setting" element={<QrSetting />} />
          <Route path="/account-setting" element={<AccountSetting />} />
          <Route path="/deposit-chfs" element={<DepositChfs />} />

          <Route path="/penalty-history" element={<PenaltyHistory />} />
          <Route path="/bonus-history" element={<BonusHistory />} />
          <Route path="/deposit-history" element={<DepositHistory />} />
          <Route path="/withdraw-history" element={<WithdrawHistory />} />
          <Route path="/add-mails" element={<AddGmail />} />
          <Route path="/mails" element={<MailList />} />

          <Route path="/penalty-report" element={<PenaltyReport />} />
          <Route path="/bonus-report" element={<BonusReport />} />
          <Route path="/deposit-report" element={<DepositReport />} />
          <Route path="/withdraw-report" element={<WithdrawReport />} />
          <Route path="/aviator-game-settings" element={<AviatorGameSetting />} />
          <Route path="/general-settings" element={<GeneralSetting />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/content-list" element={<ContentList />} />

        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Toaster
        position="top-right"
        gutter={10}
        toastOptions={{
          duration: 3200,
          style: {
            background: "linear-gradient(135deg, #fffefd 0%, #fbf6ea 100%)",
            color: "#2a2118",
            fontSize: "14px",
            border: "1px solid #eadcbe",
            borderLeft: "4px solid #d7a23a",
            borderRadius: "14px",
            boxShadow: "0 18px 44px rgba(43, 31, 15, 0.16)",
            padding: "13px 15px",
            maxWidth: "420px",
          },
          success: { iconTheme: { primary: "#17845a", secondary: "#fff" } },
          error: { iconTheme: { primary: "#d93a48", secondary: "#fff" } },
        }}
      />
    </BrowserRouter>
  );
};

export default App;
